import logo from '@assets/logo.png';
import RealAuthenticationLogo from '@assets/brand_real authentication.png';
import { realAuthenticationMerchantID, COBRANDING_LOGO } from '@constants';
import help from '@/assets/help.svg';
import classes from './index.module.css';

const TITLE_TEXT = 'Resolution Center';

// 后续co-branding的都在这里判断
const getCoBrandingLogo = (platform, merchantId) => {
  if (realAuthenticationMerchantID.includes(merchantId)) {
    return RealAuthenticationLogo;
  }
  return COBRANDING_LOGO[platform] || '';
};

export const Navigation = ({ platform, merchantId }) => {
  const centerLogo = getCoBrandingLogo(platform, merchantId);
  return (
    <nav className={classes.navigationBar}>
      <section className={classes.left}>
        {
          !centerLogo && (
            <section className={classes.logo}>
              <img src={logo} className={classes.logoIcon} alt="" />
            </section>
          )
        }

        <section className={`${classes.title} ${centerLogo ? classes.real_auth_title : ''}`}>
          {TITLE_TEXT}
        </section>

      </section>
      {
        centerLogo
        && (
          <section className={`${classes.right} ${centerLogo ? classes.real_auth : ''}`}>
            <img src={centerLogo} alt="" className={`${classes.platform_logo} ${centerLogo ? classes.real_auth_logo : ''}`} />
          </section>
        )
      }
      <a
        className={classes.help_content}
        href="https://kover2618.zendesk.com/hc/en-us/categories/8621004064155-Shoppers"
        rel="noreferrer"
        target="_blank"
      >
        <img alt="help" src={help} />
        Help
      </a>
    </nav>
  );
};
